import { selectAllNodes, selectNode } from './helpers';
import { handleSubmit } from './cart';
import {cardText} from "./checkout";

function scrollBack(startPoint) {
  window.scroll(0, startPoint);
}

function getAccessoriesData(id) {
  return jQuery.ajax({
    url: window.sharedResources.ajaxurl,
    type: 'POST',
    data: {
      action: 'get-accessories',
      id
    }
  });
}

export default function accessoryModal() {
  const accessoryItems = selectAllNodes('accessory-item');
  const modal = selectNode('acc-modal');
  const contentWrapper = selectNode('acc-modal__content-wrapper', modal);
  const content = selectNode('acc-modal__content', modal);
  const closeBtn = selectNode('acc-modal__close-btn', modal);

  let scrollY = 0;

    const closeModal = e => {
        if (e) e.preventDefault();
        contentWrapper.classList.remove("visible");
        content.classList.remove("loading");
        scrollBack(scrollY);
        window.setTimeout(() => modal.classList.remove("opened"), 350);
    };

  const activateModal = item => async e => {
    e.preventDefault();

    scrollY = window.scrollY;
    modal.classList.add('opened');
    content.innerHTML = await getAccessoriesData(item.dataset.id);
    contentWrapper.classList.add('visible');
      cardText()

    const handleClick = e => {
      handleSubmit(content)(e);
      document.addEventListener('product-submited', closeModal)
    };

    selectNode('add-to-cart', content).addEventListener('click', handleClick);
  };

  accessoryItems.map(item =>
    item.addEventListener('click', activateModal(item))
  );
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
}
